import { takeLatest, put, call, SagaReturnType } from 'redux-saga/effects';
import { laborHoursConstant } from 'src/redux/actions/constant';
import laborHoursService from 'src/services/apiServices/laborHoursService/laborHoursService';

function* getLaborReport(action: any): SagaReturnType<any> {
  try {
    yield put({ type: laborHoursConstant.GET_LABOR_REPORT_LOADER });
    const response = yield call(laborHoursService.getLaborReport, action.payload);
    if (response?.status === 200) {
      yield put({ type: laborHoursConstant.GET_LABOR_REPORT_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: laborHoursConstant.GET_LABOR_REPORT_FAILURE, payload: error });
  }
}

function* getLaborReportSaga() {
  // takeLatest — paging between pay periods fires back-to-back requests and only the
  // most recent period's rows should land in the table.
  yield takeLatest(laborHoursConstant.GET_LABOR_REPORT_REQUEST, getLaborReport);
}

export default getLaborReportSaga;
